<template>
  <div class="form-container">
    <FormInput
      data-testid="support-ticket-issue"
      :initial-value="issue"
      :input-props="{
        label: 'Issue',
        required: true,
        id: 'support_ticket_issue',
        disabled: disabled,
      }"
      name="issue"
    />
    <FormInput
      data-testid="support-ticket-type"
      :initial-value="selectedType"
      :input-props="{
        label: 'Type',
        required: true,
        options: ticketTypes,
        id: 'support_ticket_type',
        disabled: disabled,
      }"
      name="type"
      type="select"
    />
    <FormInput
      data-testid="support-ticket-description"
      :initial-value="description"
      :input-props="{
        label: 'Description',
        required: true,
        id: 'support_ticket_description',
        disabled: disabled,
      }"
      name="description"
      type="textarea"
    />
    <FormInput
      data-testid="support-ticket-priority"
      :initial-value="priority"
      :input-props="{
        label: 'Priority',
        options: [
          { id: 1, label: 'Low', value: 'LOW' },
          { id: 2, label: 'Medium', value: 'MEDIUM' },
          { id: 3, label: 'High', value: 'HIGH' },
        ],
        id: 'support_ticket_priority',
        disabled: disabled,
      }"
      name="priority"
      type="select"
    />
    <FormInput
      data-testid="support-ticket-location"
      :initial-value="selectedLocation"
      :input-props="{
        label: 'Location',
        required: true,
        options: clientLocations,
        id: 'support_ticket_location',
        disabled: disabled,
      }"
      name="location"
      type="select"
    />
  </div>
  <div class="submit-button cr-mx-auto">
    <BaseButton
      v-if="!disabled"
      data-testid="support-ticket-submit"
      emphasis="high"
      text="Submit"
      @click="submitTicket"
    />
    <a
      v-else
      href="/client/support"
    >
      <BaseButton
        data-testid="support-ticket-go-to-support"
        emphasis="regular"
        text="Go to Support Center"
      />
    </a>
  </div>
</template>

<script>
import FormInput from './FormInput.vue'
import BaseButton from './BaseButton.vue'
import { ClientSupportService } from '../services/api/modules/client_support_service'
import { FORM_LANGUAGE } from '../helpers/form_helpers.js'
import { useForm } from 'vee-validate'
import { object, string } from 'yup'

export default {
  name: 'SupportForm',
  components: {
    FormInput,
    BaseButton,
  },
  props: {
    issue: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    priority: {
      type: String,
      required: true,
    },
    clientLocations: {
      type: Array,
      required: true,
    },
    ticketTypes: {
      type: Array,
      required: true,
    },
    selectedType: {
      type: String,
      required: true,
    },
    selectedLocation: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit'],
  setup() {
    const { values, handleSubmit } = useForm({
      validationSchema: object({
        issue: string().required(FORM_LANGUAGE.required),
        description: string().required(FORM_LANGUAGE.required),
        priority: string().required(FORM_LANGUAGE.required),
        location: string().required(FORM_LANGUAGE.required),
        type: string().required(FORM_LANGUAGE.required),
      }),
    })

    return {
      values,
      handleSubmit,
    }
  },
  methods: {
    submitTicket() {
      const ticket = {
        subject: this.values.issue,
        content: this.values.description,
        priority: this.values.priority,
        location_id: this.values.location,
        type: this.values.type,
      }

      const params = {
        ticket: ticket,
      }

      const submitFn = this.handleSubmit(async () => {
        ClientSupportService.postTicket(params)
        this.$emit('submit', 'success')
      })

      submitFn()
    },
  },
}

</script>

<style scoped lang="scss">
.form-container {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-bottom: var(--space-4);
}
</style>
